import React from 'react'
import OneColWrapper from '../technical/OneColWrapper'
import Kleber from '../../assets/images/polaroid-kleber.svg'
import Image from '../atoms/Image'
import Polaroid from '../atoms/Polaroid'

const PolaroidBlock = ({ block }) => {
  return (
    <OneColWrapper block={block} className="polaroid-block">
      <Polaroid image={block.image} alt={block.alt} caption={block.caption} />
    </OneColWrapper>
  )
}

export default PolaroidBlock
